const actions = {
    COUNTRY_ADD_NEW: 'COUNTRY_ADD_NEW',
    COUNTRY_READ: 'COUNTRY_READ',
    COUNTRY_READ_SUCCESS: 'COUNTRY_READ_SUCCESS',
    COUNTRY_UPDATE: 'COUNTRY_UPDATE',
    COUNTRY_FIND_BY_ID: 'COUNTRY_FIND_BY_ID',
    COUNTRY_LIST_SUCCESS: 'COUNTRY_LIST_SUCCESS',
    COUNTRY_ITEM_SUCCESS: 'COUNTRY_ITEM_SUCCESS',

    
    countryAddNew:(history, dataObj) => ({ //Action creator function
      type: actions.COUNTRY_ADD_NEW, //Action
      payload: { history, dataObj } //pass payload to action, we should pass as little data to action
    }),

    countryRead:(readFilter, page) => ({ //Action creator function
      type: actions.COUNTRY_READ, //Action
      payload: { readFilter, page } //pass payload to action, we should pass as little data to action
    }),
    onPageChange: (info, page) => ({
      type: actions.COUNTRY_READ,
      payload: { info, page }
    }),
    countryReadSearchSuccess: (data, success, total_count, page) => ({
      type: actions.COUNTRY_READ_SUCCESS,
      data,
      success,
      total_count,
      page,
    }),

    countryFindById: (countryId) => ({
      type: actions.COUNTRY_FIND_BY_ID,
      payload: { countryId }
    }),

  

  };
  export default actions;